const TextInput = ({ value, onChange, onPaste, maxLength }) => {
  return (
    <textarea
      value={value}
      onChange={onChange}
      onPaste={onPaste}
      maxLength={maxLength}
      className="w-full min-h-[150px] p-3 border rounded-md"
      placeholder="Enter text to translate..."
    />
  );
};

export default TextInput;
